import { render, staticRenderFns } from "./Add_topic.vue?vue&type=template&id=070f60bc&style=height%3A100%25"
import script from "./Add_topic.vue?vue&type=script&lang=js"
export * from "./Add_topic.vue?vue&type=script&lang=js"
import style0 from "./Add_topic.vue?vue&type=style&index=0&id=070f60bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports